module.exports = __webpack_public_path__ + "img/smartmessage-logo.e9f9e675.svg";